<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Retur</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalRetur | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Laporan Retur Product</h4>
                        <div class="form-inline">
                            <span><b>Company:</b></span>
                            <select v-model="company_no" class="form-control">
                                <option value="">-- All --</option>
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                            <span><b>Type</b></span>
                            <select v-model="type" class="form-control">
                                <option value="purchasing">Purchasing</option>
                                <option value="sales">Sales</option>
                            </select>
                            <span><b>Date:</b></span>
                            <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                            <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                                <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                            </button>
                            <!-- <button type="button" class="btn btn-sm btn-soft-primary" @click="processReport">Process</button> -->
                            <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" /> -->
                          <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-print" aria-hidden="true"></i> Print
                          </button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#return-raw" data-toggle="tab" aria-expanded="false" class="nav-link active">Retur</a></li>
                            <li class="nav-item"><a href="#return-product" data-toggle="tab" aria-expanded="false" class="nav-link">Retur By Group</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="return-raw">
                              <div class="table-responsive">
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                          <th>Type</th>
                                          <th>Date</th>
                                          <th>Return No.</th>
                                          <th>Product</th>
                                          <th>
                                            <span v-if="type === 'purchasing'">Vendor</span>
                                            <span v-else>Customer</span>
                                          </th>
                                          <th>Qty</th>
                                          <th>Uom</th>
                                          <th class="text-right">Amount</th>
                                          <th class="text-right">Discount</th>
                                          <th class="text-right">Tax</th>
                                          <th class="text-right">Total</th>
                                      </thead>
                                      <tbody>
                                          <tr v-for="a in returnRaw" :key="a.id">
                                              <td>
                                                  <span class="badge badge-success" v-if="a.type === 'purchasing'">{{ a.type }}</span>
                                                  <span class="badge badge-primary" v-else-if="a.type === 'sales'">{{ a.type }}</span>
                                              </td>
                                              <td>{{ a.return_date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td>
                                                <span class="text-ref-sales" v-if="a.type === 'purchasing'" @click="showReturPuchasing(a.return_no)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ a.return_no }}</span>
                                                <span class="text-ref-sales" v-else-if="a.type === 'sales'" @click="showReturSales(a.return_no)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ a.return_no }}</span>
                                              </td>
                                              <td><b>[{{ a.product_no }}]</b> {{ a.product }}</td>
                                              <td><b>{{ a.ref }}</b></td>
                                              <td>{{ a.qty}}</td>
                                              <td>{{ a.uom_id }}</td>
                                              <td class="text-right">{{ a.amount | currency }}</td>
                                              <td class="text-right">{{ a.discount | currency }}</td>
                                              <td class="text-right">{{ a.tax | currency }}</td>
                                              <td class="text-right">{{ a.total | currency }}</td>
                                          </tr>
                                      </tbody>
                                      <tfoot>
                                          <tr>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                          </tr>
                                      </tfoot>
                                  </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="return-product">
                              <div v-for="i in filterData" :key="i.id">
                                  <h5 class="text-center" style="margin-top: 20px"><b>{{ i.name }}</b></h5>
                                  <hr/>
                                  <div class="table-responsive">
                                      <table class="table table-item mb-0 table-sm table-striped table-hover">
                                          <thead>
                                              <th>Type</th>
                                              <th>Date</th>
                                              <th>Return No.</th>
                                              <th>Product</th>
                                              <th>
                                                <span v-if="type === 'purchasing'">Vendor</span>
                                                <span v-else>Customer</span>
                                              </th>
                                              <th>Qty</th>
                                              <th>Uom</th>
                                              <th class="text-right">Amount</th>
                                              <th class="text-right">Discount</th>
                                              <th class="text-right">Tax</th>
                                              <th class="text-right">Total</th>
                                          </thead>
                                          <tbody>
                                              <tr v-for="a in i.return" :key="a.id">
                                                  <td>
                                                      <span class="badge badge-success" v-if="a.type === 'purchasing'">{{ a.type }}</span>
                                                      <span class="badge badge-primary" v-else-if="a.type === 'sales'">{{ a.type }}</span>
                                                  </td>
                                                  <td>{{ a.return_date | dateFormat('DD/MM/YYYY') }}</td>
                                                  <td>
                                                    <span class="text-ref-sales" v-if="a.type === 'purchasing'" @click="showReturPuchasing(a.return_no)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ a.return_no }}</span>
                                                    <span class="text-ref-sales" v-else-if="a.type === 'sales'" @click="showReturSales(a.return_no)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ a.return_no }}</span>
                                                  </td>
                                                  <td><b>[{{ a.product_no }}]</b> {{ a.product }}</td>
                                                  <td><b>{{ a.ref }}</b></td>
                                                  <td>{{ a.qty}}</td>
                                                  <td>{{ a.uom_id }}</td>
                                                  <td class="text-right">{{ a.amount | currency }}</td>
                                                  <td class="text-right">{{ a.discount | currency }}</td>
                                                  <td class="text-right">{{ a.tax | currency }}</td>
                                                  <td class="text-right">{{ a.total | currency }}</td>
                                              </tr>
                                          </tbody>
                                          <tfoot>
                                              <tr>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td></td>
                                                  <td class="text-right"><b>{{ i.total_return | currency }}</b></td>
                                              </tr>
                                          </tfoot>
                                      </table>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <ReturnModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { reportTransactionUrl, returnUrl, report2Url, getHeader } from '@/config'
import DatePicker from 'vue2-datepicker'
import ReturnModal from '@/components/return/ReturnModal.vue'

export default {
  name: 'ReturnReportProduct',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    ReturnModal
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getUrcFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      type: 'purchasing',
      filterType: [],
      loadingSales: true,
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      dataRaw2: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser
    }),
    returnRaw () {
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var retur = array[i].return
        for (let a = 0; a < retur.length; a++) {
          var obj = {
            id: retur[a].id,
            type: retur[a].type,
            return_no: retur[a].return_no,
            product_no: retur[a].product_no,
            product: retur[a].product,
            product_sku: retur[a].product_sku,
            serial_number: retur[a].serial_number,
            uom_id: retur[a].uom_id,
            qty: retur[a].qty,
            amount: retur[a].amount,
            notes: retur[a].notes,
            warehouse_no: retur[a].warehouse_no,
            branch_no: retur[a].branch_no,
            company_no: retur[a].company_no,
            company: retur[a].company,
            discount: retur[a].discount,
            discount_percentage: retur[a].discount_percentage,
            tax_id: retur[a].tax_id,
            tax: retur[a].tax,
            total: retur[a].total,
            return_date: retur[a].return_date,
            cost: retur[a].cost,
            cost_id: retur[a].cost_id,
            ref_no: retur[a].ref_no,
            ref: retur[a].ref
          }
          loop.push(obj)
        }
      }
      return loop
    },
    totalRetur () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_return)
      }
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        for (let i = 0; i < d.return.length; i++) {
          if (this.filterType.length > 0) {
            for (let i = 0; i < this.filterType.length; i++) {
              if (this.filterType[i] === d.return[i].type) {
                return d
              }
            }
          } else {
            return d
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    showReturSales (no) {
      var payload = {
        return_no: no
      }
      this.$store.commit('SET_RETURN_BY_NO', payload)
      this.$store.dispatch('getReturnByNo', payload)
    },
    async showReturPuchasing (no) {
      var payload = {
        return_no: no
      }
      this.$store.commit('SET_RETURN_BY_NO', payload)
      this.$store.dispatch('getReturnByNo', payload)
    },
    async uncheckReportPayment (id, refNo) {
      var array = this.selected
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === id) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: refNo
        }
        await axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshListRaw () {
      this.$Progress.start()
      this.load.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var body = {
        begin: begin,
        end: end,
        type: this.type,
        company_no: this.company_no
      }
      await axios.post(returnUrl + '/detail/list', body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.dataRaw2 = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        type: this.type
      }
      console.log(obj)
      console.log(returnUrl + '/report-by-product')
      await axios.post(returnUrl + '/report-by-product', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async processReport () {
      this.$Progress.start()
      this.loader.isLoading = true
      for (let c = 0; c < this.selected.length; c++) {
        var data = this.dataRaw.find(d => d.id === this.selected[c])
        var obj = {
          cash_id: data.id,
          company_no: data.company_no,
          report_date: data.cash_date
        }
        await axios.post(reportTransactionUrl + '/create-cash-on-hand', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(report2Url + '/product-return', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
